import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  smallLayout: {
    margin: '25vh 1.5em 1.5em 1.5em',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      height: '100vh',
    },
  },
});

const SmallPaper = props =>
  ((props.children) ?
    <Grid item xs={12} sm={8} md={6} lg={3}>
        <Paper className={props.classes.smallLayout}>
            {props.children}
        </Paper>
    </Grid>
    : null);

SmallPaper.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(SmallPaper);



// WEBPACK FOOTER //
// ./src/components/Layout/SmallPaper.jsx